import { Link, useNavigate } from 'react-router-dom';
import WaveLogo from '@/ui/WaveLogo/WaveLogo';
import LoginByCode from '@/ui/LoginByCode/LoginByCode';

/**
 * Standalone sign-in page (ROU-972). Creators log in via the OTP flow without
 * needing an invite or campaign link; on success we land them on the home
 * wallet. Authenticated visitors are redirected off /login in App routing.
 */
const LoginPage = () => {
    const navigate = useNavigate();

    return (
        <div className="wm-root wm-auth flex min-h-[100dvh] flex-col items-center justify-center bg-wm-bg px-5 py-12">
            <div className="mx-auto w-full max-w-sm">
                <WaveLogo size="md" className="mx-auto mb-6" />
                <div
                    className="rounded-wm-lg border border-wm-line bg-wm-surface px-6 py-7"
                    style={{ boxShadow: 'var(--wm-shadow-2)' }}
                >
                    <LoginByCode onAuthenticated={() => navigate('/', { replace: true })} />
                </div>
                <p className="mt-5 text-center text-sm text-wm-ink-3">
                    New to Wave?{' '}
                    <Link to="/signup" className="wm-btn wm-btn--link">
                        Apply to join
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default LoginPage;
